import React from 'react';
import './PhotoGrid.css';

export default function PhotoGrid({
	title,
	photos,
	gridClass = 'default-grid',
}) {
	return (
		<section className='photo-grid-section'>
			{title && <h2 className='photo-grid-title'>{title}</h2>}
			<div className={`pictures ${gridClass}`}>
				{photos.map((photo, index) => (
					<img key={index} src={photo} alt={title || 'photo'} className='pic' />
				))}
			</div>
		</section>
	);
}
